export interface IDisplayableUserProfile {
    uid: string;
    readonly nickname: string;
    readonly fullname: string;
    readonly username: string;
    readonly avatarName: string;
    available?: boolean;
    eligable?: boolean;
    accepted?: boolean;
    privateProfile?: boolean;
    availabilityCheckedFor?: Date;
    avatarPicture?: string;
    isInWhiteList?: boolean;
}

export class DisplayableUserProfile {
    public static AsDisplayableUserProfile(
        obj: IDisplayableUserProfile,
        isInWhiteList?: boolean,
    ): IDisplayableUserProfile {
        return {
            uid: obj.uid,
            nickname: obj.nickname,
            fullname: obj.fullname,
            username: obj.username,
            avatarName: obj.avatarName,
            available: obj.available,
            eligable: obj.eligable,
            privateProfile: obj.privateProfile,
            availabilityCheckedFor: obj.availabilityCheckedFor,
            avatarPicture: obj.avatarPicture,
            isInWhiteList,
        } as IDisplayableUserProfile;
    }
}
